import React from "react";
import { useState, useEffect } from "react";
import { FaWhatsapp } from "react-icons/fa";
import { FaPhone } from "react-icons/fa6";
import { useNavigate, useLocation } from "react-router-dom";
import { useFormik } from "formik";
import * as Yup from "yup";
import { MdPhone } from "react-icons/md";
import { Link } from "react-router-dom";

const images = [
  "images/BANNER/1.jpg",
  "images/BANNER/2.jpg",
  "images/BANNER/3.jpg",
  "images/BANNER/4.jpg",
];

const galleryImages = [
  // {
  //   src: "images/GALLERY/1.jpg",
  //   url: "/lodha-projects",
  // },
  // {
  //   src: "images/GALLERY/3.jpg",
  //   url: "/lnt",
  // },
   {
    src: "images/Lodha/1.jpg",
    url: "https://riservo-vikhroli.central-mumbai.co.in/",
  },
  // {
    //   src: "images/GALLERY/9.jpg",
    //   url: "/rustomjee"
    // },
  // {
  //   src: "images/GALLERY/13.jpg",
  //   url: "/raghav"
  // },
  
  {
    src: "images/GALLERY/4.jpg",
    url: "https://vistas-vikhroli.central-mumbai.co.in/",
  },
  {
    src: "images/Raheja/1.jpg",
    url: "https://antares-kanjurmarg.central-mumbai.co.in/",
  },
  {
    src: "images/GALLERY/5.jpg",
    url: "https://chandak-highscape-city-chembur.central-mumbai.co.in/"
  },
  {
    src: "images/GALLERY/7.jpg",
    url: "https://hubtown-rising-city-ghatkopar.central-mumbai.co.in/"
  },
  {
    src: "images/Raymond/RAYMOND REALTY - THE ADDRESS BY GS - SION.jpg",
    url: "https://raymond-sion.central-mumbai.co.in/"
  },
  // {
  //   src: "images/GALLERY/10.jpg",
  //   url: "https://atulhillfront-mulundhills.central-mumbai.co.in/"
  // },
  // {
  //   src: "images/GALLERY/11.jpg",
  //   url: "https://bkc9-bandra.central-mumbai.co.in/"
  // },
  {
    src: "images/GALLERY/12.jpg",
    url: "https://gurukrupa-marque-bandra.central-mumbai.co.in/"
  }
];

const BodyContent = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [currentIndex, setCurrentIndex] = useState(0);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [formError, setFormError] = useState(false);
  const totalImages = images.length;

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % totalImages);
    }, 3000);

    return () => clearInterval(interval);
  }, [totalImages]);

  useEffect(() => {
    const hash = location.hash;
    if (hash) {
      const element = document.getElementById(hash.replace("#", ""));
      if (element) {
        element.scrollIntoView({ behavior: "smooth" });
      }
    }
  }, [location]);

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % totalImages);
  };

  const prevSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex - 1 + totalImages) % totalImages);
  };

  // Yup validation schema
  const validationSchema = Yup.object({
    name: Yup.string().required("Name is required"),
    phone: Yup.string()
      .required("Phone is required")
      .matches(/^\d{10}$/, "Phone number must be 10 digits long"),
  });

  // Formik setup
  const formik = useFormik({
    initialValues: {
      name: "",
      phone: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      const formData = new FormData();
      formData.append("Name", values.name);
      formData.append("Phone", values.phone);

      const crmData = {
        name: values.name,
        phone: values.phone,
        listId: "689daa690701f3dd6529f3f1", // Add your listId for CRM
        redirect: "", // Add your redirect URL for CRM
      };

      try {
        setIsSubmitted(true);
        // Send data to Google Sheets
        await fetch(
          "https://script.google.com/macros/s/AKfycbyXc8JS1Z7awk2XGonelqqDfugsMimcwMbkbjl5MPBQp8qdDxoQBayjlg_SJ4fVWsDk/exec",
          {
            method: "POST",
            mode:"no-cors",
            body: formData,
          }
        );

        // Send data to CRM
        await fetch(
          "https://enterprise.godial.cc/meta/api/externals/contact/add?access_token=nbcLc99ivtoh5FO8xqGEOZEW6ddcb4szdtvHdVNCeTh980VQNehbfScBK0MvbQTb",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(crmData),
          }
        );

        formik.resetForm({ name: "", phone: "" });

        // Redirect to thank-you page
        navigate("/thank-you");
      } catch (error) {
        setFormError(true);
        console.log(error);
      }
    },
  });

  return (
    <>
      <div>
        <div className="flex flex-col lg:flex-row " id="home">
          <div className="relative w-full lg:w-[75%] h-1/2 lg:h-auto">
            <img
              src={images[currentIndex]}
              alt="slider"
              className="w-full h-full object-fill"
            />
            <button
              className="absolute left-2 top-1/2 transform -translate-y-1/2 text-2xl text-white p-2 rounded-full"
              onClick={prevSlide}
            >
              <img
                src="images/LEFT_ARR-removebg-preview.png"
                alt="Previous"
                className="w-6 h-6" // Adjust the width and height to match the size of the ChevronLeft icon
              />
            </button>
            <button
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-2xl text-white p-2 rounded-full"
              onClick={nextSlide}
            >
              <img
                src="images/RIGHT_ARR__2_-removebg-preview.png"
                alt="Previous"
                className="w-6 h-6" // Adjust the width and height to match the size of the ChevronLeft icon
              />
            </button>
          </div>
          <div className="w-full lg:w-[25%] h-auto lg:h-full bg-[#f7f5dd] p-2 my-4 flex flex-col items-center border-5 border-[#126958] sm:border-5 lg:border-none">
            <h2 className="text-lg sm:text-xl lg:text-2xl font-bold text-center mt-2">
              CENTRAL MUMBAI PROJECTS
            </h2>
            <div className="flex flex-col items-center border-2 border-black m-4 text-center w-full">
              <h2 className="text-lg sm:text-xl lg:text-2xl font-bold">
                Contact Details
              </h2>

              <div className="flex items-center justify-center space-x-2 text-white bg-[#126958] px-4 py-2 w-full sm:w-4/5 h-[50px] sm:h-[45px] lg:h-[50px] rounded-lg m-2 my-6">
                <MdPhone />
                <span
                  className="text-sm sm:text-base lg:text-lg"
                  onClick={() => window.open("tel:9326959938")}
                >
                  {" "}
                  +91 93269 59938
                </span>
              </div>
            </div>
          </div>
        </div>

        <div className="container mx-auto px-1 sm:px-8" id="gallery">
          <h1 className="text-4xl sm:text-4xl md:text-5xl lg:text-[48px] font-bold text-center my-8 transition-all duration-300">
            CENTRAL MUMBAI PROJECTS
          </h1>
          <div className="flex flex-wrap gap-[1vh] p-[1vh] max-w-full mx-auto bg-[#126958] justify-center">
            {galleryImages.map((image, index) => {
              const isExternal = image.url.startsWith("http"); // Check if the URL is external
              return (
                <div
                  className="gallery-item group w-full sm:w-[calc(50%-1vh)] md:w-[calc(33.333%-1vh)]"
                  key={index}
                >
                  {isExternal ? (
                    <a
                      href={image.url}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {/* For external URLs, use a regular <a> tag */}
                      <img
                        src={image.src}
                        alt={`Gallery ${index + 1}`}
                        className="w-full h-[300px] object-fill transition-all duration-100 ease-out group-hover:scale-104 group-hover:filter-none"
                      />
                    </a>
                  ) : (
                    <Link to={image.url}>
                      {/* For internal URLs, use the <Link> component */}
                      <img
                        src={image.src}
                        alt={`Gallery ${index + 1}`}
                        className="w-full h-[300px] object-fill transition-all duration-100 ease-out group-hover:scale-104 group-hover:filter-none"
                      />
                    </Link>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <section
          id="contact-us"
          className="px-4 py-8 sm:px-6 sm:py-10 lg:px-8 lg:py-12"
        >
          <h1 className="text-center my-4 text-2xl sm:text-3xl md:text-4xl lg:text-[48px] lg:font-bold font-semibold uppercase text-black-800">
            CONTACT US
          </h1>

          <div className="flex justify-center items-center mb-6">
            <FaPhone
              onClick={() => window.open("tel:9326959938")}
              style={{
                color: "white",
                backgroundColor: "green",
                borderRadius: "50%",
                fontSize: "30px",
                padding: "5px",
                marginRight: "10px",
              }}
            />
            <span
              className="text-lg sm:text-xl md:text-2xl lg:text-3xl cursor-pointer"
              onClick={() => window.open("tel:9326959938")}
            >
              {" "}
              +91 93269 59938{" "}
            </span>
          </div>

          <h3 className="text-center text-sm font-black sm:text-4xl md:text-lg lg:text-xl font-calibri mb-6">
            Exclusive Limited Time Offer: Unbeatable Discounts Await You!
          </h3>

          <div className="container-f mx-auto max-w-xl">
            {isSubmitted && !formError ? (
              <div className="w-2/5 text-center bg-[#126958] text-[#fff] mx-auto py-2 border-1 border-[#520808]">
                <h4 className="text-2xl">Successfully Submitted</h4>
                <h3 className="text-xl">
                  Thank you! We will contact you soon.
                </h3>
              </div>
            ) : formError ? (
              <div className="text-center bg-[#ffff00] text-[#E72744] mx-4 p-4 border-1 border-[#520808]">
                <p className="text-2xl">
                  Something went wrong. Please try again.
                </p>
              </div>
            ) : (
              <form onSubmit={formik.handleSubmit} className="space-y-4">
                <div className="form-group">
                  <input
                    className="form-control w-full px-4 py-2 text-sm sm:text-base md:text-lg border rounded-md"
                    type="text"
                    id="name"
                    name="name"
                    placeholder="Enter your name"
                    value={formik.values.name}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.name && formik.errors.name && (
                    <span className="text-red-500 text-sm">
                      {formik.errors.name}
                    </span>
                  )}
                </div>

                <div className="form-group">
                  <input
                    className="form-control w-full px-4 py-2 text-sm sm:text-base md:text-lg border rounded-md"
                    type="text"
                    id="phone"
                    name="phone"
                    placeholder="Enter your number"
                    value={formik.values.phone}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                  />
                  {formik.touched.phone && formik.errors.phone && (
                    <span className="text-red-500 text-sm">
                      {formik.errors.phone}
                    </span>
                  )}
                </div>

                <button
                  className="glow-on-hover w-full py-auto px-4 text-white rounded-md text-xs sm:text-sm md:text-lg lg:text-xl"
                  type="submit"
                >
                  Book Free Site Assistance
                </button>
              </form>
            )}
          </div>
        </section>

        <div className="foot_top bg-gray-800 text-white py-8 text-center">
          <div className="container mx-auto px-4">
            <div className="row">
              <div className="col-md-12 mx-auto">
                <div className="foot_left">
                  <h1 className="text-2xl md:text-4xl font-bold">
                    CENTRAL MUMBAI PROJECTS
                  </h1>
                  <p className="mt-4 text-base md:text-lg text-justify">
                    Disclaimer: This website is meant only for information
                    purposes. It should not be considered / claimed as an
                    official site. This website belongs to the authorized
                    channel partner. The content provided on this website is for
                    information purposes only and does not constitute an offer
                    to avail any service. The prices mentioned are subject to
                    change without prior notice, and the availability of
                    properties mentioned is not guaranteed. The images displayed
                    on the website are for representation purposes only and may
                    not reflect the actual properties accurately. We may share
                    data with Real Estate Regulatory Authority (RERA) registered
                    brokers/companies for further processing as required. We may
                    also send updates and information to the mobile number or
                    email ID registered with us. All rights reserved. The
                    content, design, and information on this website are
                    protected by copyright and other intellectual property
                    rights. Any unauthorized use or reproduction of the content
                    may violate applicable laws.
                  </p>
                </div>

                <h3 className="text-center justify" style={{ color: "#fff" }}>
                  MahaRERA registration number: A52000032416
                  maharera.mahaonline.gov.in
                </h3>
              </div>
            </div>
          </div>
        </div>

        <a
          href="https://api.whatsapp.com/send?phone=9326959938&text=I am interested in Central Mumbai Projects and want more information about this project."
          className="floating-button"
          target="_blank"
          rel="noreferrer"
        >
          <div className="floating-btn">
            <FaWhatsapp size={30} />
          </div>
        </a>
      </div>
    </>
  );
};

export default BodyContent;
